import CustomWebcam from './CustomWebCam';

export default CustomWebcam;
